import {
  color_black,
  color_grey_dark,
  color_grey_light,
  color_grey_ultra_light,
  color_red_default,
  color_white,
} from "../../../../constants/colors";

export const styles = {
  infoEditContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
  },
  infoEditForm: {
    display: "flex",
    flexDirection: "column",
    gap: 28,
  },
  scheduleSectionCard: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: 20,
    borderRadius: 16,
    backgroundColor: color_grey_ultra_light,
    boxSizing: "border-box",
  },
  scheduleSectionTitle: {
    margin: 0,
  },
  weekdaySelectorContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
    gap: 8,
    width: "100%",
  },
  weekDaySelectorButton: {
    width: "100%",
    minWidth: 0,
    height: 40,
    borderRadius: 10,
    backgroundColor: color_white,
    color: color_black,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxSizing: "border-box",
    border: "none",
  },
  weekDaySelectorButtonActive: {
    backgroundColor: color_red_default,
    color: color_white,
  },
  timeSelectContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  timeTableHeaderRow: {
    display: "grid",
    gridTemplateColumns: "108px minmax(0, 1fr) 48px",
    gap: 8,
    padding: "0 2px 8px",
    marginBottom: 2,
    borderBottom: `1px solid ${color_grey_light}`,
  },
  timeTableHeaderTimeRange: {
    display: "grid",
    gridTemplateColumns: "1fr auto 1fr",
    gap: 6,
    alignItems: "center",
    minWidth: 0,
  },
  timeTableHeaderCell: {
    fontFamily: "Onest",
    fontSize: 11,
    fontWeight: 500,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: color_grey_dark,
    lineHeight: "120%",
  },
  timeSelect: {
    width: 80,
    height: 40,
    backgroundColor: color_white,
    color: color_black,
    borderRadius: 10,
    border: `1px solid ${color_grey_light}`,
    paddingLeft: 10,
    paddingRight: 6,
    textAlign: "left",
    fontFamily: "Onest",
    outline: "none",
    appearance: "none",
    WebkitAppearance: "none",
    fontSize: 18,
    boxSizing: "border-box",
  },
  timeFieldInput: {
    width: "100%",
    height: 40,
    backgroundColor: color_white,
    color: color_black,
    borderRadius: 10,
    border: `1px solid ${color_grey_light}`,
    paddingLeft: 12,
    paddingRight: 14,
    textAlign: "left",
    fontFamily: "Onest",
    outline: "none",
    appearance: "none",
    WebkitAppearance: "none",
    fontSize: 16,
    boxSizing: "border-box",
  },
  timeRangeGroup: {
    display: "grid",
    gridTemplateColumns: "1fr auto 1fr",
    gap: 6,
    alignItems: "center",
    minWidth: 0,
  },
  timeRangeArrow: {
    color: color_grey_dark,
    flexShrink: 0,
    lineHeight: 1,
    paddingBottom: 2,
  },
  timeFieldWrapper: {
    position: "relative",
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
  },
  radioBoxRow: {
    display: "flex",
    alignItems: "center",
    marginTop: 8,
  },
};
